import React from "react";

export default function Loading() {
    /*return <div className="loadingWrapper">
        <CircularProgress />
    </div>*/
    return <></>;
}
